(() => {
  const navigation = document.querySelector('.lest-header__nav');
  if (!navigation) return;

  const menus = [...navigation.querySelectorAll('details')];
  const desktop = window.matchMedia('(min-width: 991px)');
  let openTimer;
  let closeTimer;

  const closeOthers = (current) => {
    menus.forEach((menu) => {
      if (menu !== current) menu.removeAttribute('open');
    });
  };

  menus.forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (menu.open) closeOthers(menu);
    });

    menu.addEventListener('pointerenter', (event) => {
      if (!desktop.matches || event.pointerType === 'touch') return;
      window.clearTimeout(closeTimer);
      openTimer = window.setTimeout(() => {
        closeOthers(menu);
        menu.setAttribute('open', '');
      }, 140);
    });

    menu.addEventListener('pointerleave', (event) => {
      if (!desktop.matches || event.pointerType === 'touch') return;
      window.clearTimeout(openTimer);
      closeTimer = window.setTimeout(() => menu.removeAttribute('open'), 220);
    });
  });

  document.addEventListener('pointerdown', (event) => {
    if (!event.target.closest('.lest-header__nav')) menus.forEach((menu) => menu.removeAttribute('open'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      menus.forEach((menu) => menu.removeAttribute('open'));
      navigation.querySelector('summary:focus')?.blur();
    }
  });
})();

